export default __webpack_public_path__ + "static/media/S-040.3a2615b8.png";